var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_vm._m(0),_c('LiveDemo'),_c('SearchBarMarkdown',{staticClass:"markdownStyle"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topBar"},[_c('div',{staticClass:"topic"},[_vm._v(" Search Bar ")])])
}]

export { render, staticRenderFns }